import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export function SortableItem({ id, children, disabled = false }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id, disabled });
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  
  return (
    <tr ref={setNodeRef} style={style} className="border-b border-stone-100 hover:bg-stone-50">
      <td className={`py-3 px-2 ${disabled ? '' : 'cursor-move'}`} {...(disabled ? {} : { ...attributes, ...listeners })}>
        <GripVertical className={`h-4 w-4 ${disabled ? 'text-stone-200' : 'text-muted-foreground'}`} />
      </td>
      {children}
    </tr>
  );
}
